import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioBox } from './';

export default class RadioBoxList extends Component {
  static contextTypes = {
    onChange: PropTypes.func,
    formFieldName: PropTypes.string,
    formFieldLabel: PropTypes.string,
    setType: PropTypes.func,
    getFormValue: PropTypes.func
  };

  static childContextTypes = {
    onChange: PropTypes.func,
    getFormValue: PropTypes.func,
    formFieldName: PropTypes.string,
    formFieldLabel: PropTypes.string
  };

  getChildContext() {
    return {
      onChange: null,
      getFormValue: null,
      formFieldName: null,
      formFieldLabel: null
    }
  }

  get name() {
    return this.context.formFieldName || this.props.name;
  }

  get value() {
    if (this.context.getFormValue) {
      return this.context.getFormValue(this.name);
    } else {
      return this.props.value;
    }
  }

  componentWillMount() {
    if (this.context.setType) this.context.setType('RadioBox');
  }

  handleChange(index, checked) {
    if (!checked) return;

    const { options } = this.props;
    const value = options[index].value;

    if (this.context.onChange) {
      this.context.onChange(this.context.formFieldName, value);
    }

    if (this.props.onChange) {
      this.props.onChange(value);
    }
  }

  render() {
    const { options = [] } = this.props;

    const content = options.map((option, index) => {
      return (
        <p key={index}>
          <RadioBox
            onChange={value => this.handleChange(index, value)}
            label={option.label}
            value={option.value === this.value}
          />
        </p>
      )
    });

    return (
      <div>
        {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/radio-box-list.js